'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { localStorage } from 'dibs-browser-storage';
import { getUserId, cookieJarConstants } from 'dibs-cookie-jar';

import SocialIcon from '../../../global/components/SocialIcon/SocialIcon';
import EmailIcon from 'dibs-vg/dist/react/email';
import SendToFriendModal from 'dibs-send-to-friend-modal';
import { trackEmailFriend } from '../../actions/pdpTrackingActions';

class PdpEmailIcon extends React.Component {
    constructor() {
        super();

        this.state = {
            modalOpen: false,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({ modalOpen: true });
        trackEmailFriend({ itemId: this.props.selectedItems[0].itemId });
    }

    render() {
        const { iconType } = this.props;
        const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);
        const senderEmail = userId ? localStorage.getItem('userEmail') : '';

        return (
            <div>
                <SocialIcon
                    onClick={() => this.handleClick()}
                    Icon={EmailIcon}
                    iconName="email"
                    iconType={iconType}
                    data-tn="email"
                />
                <IntlProvider locale="en">
                    <SendToFriendModal
                        relay={this.props.relay}
                        modalOpen={this.state.modalOpen}
                        closeModal={() => this.setState({ modalOpen: false })}
                        type="PDP"
                        senderEmail={senderEmail}
                        selectedItems={this.props.selectedItems}
                    />
                </IntlProvider>
            </div>
        );
    }
}

PdpEmailIcon.propTypes = {
    iconType: PropTypes.string,
    relay: PropTypes.object,
    selectedItems: PropTypes.array,
};

module.exports = PdpEmailIcon;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/social/PdpEmailIcon.jsx